module.exports = __webpack_public_path__ + "img/1.7f890e2e.png";